<template>
  <v-autocomplete
      :prepend-icon="dense ? null : 'location_city'"
      :items="items"
      :item-text="'locality'"
      :item-value="itemValue"
      v-model="item"
      :label="$t('maps.location.labels.locality')"
      :loading="loading"
      :error="hasInputErrors('locality')"
      :error-messages="getInputErrors('locality')"
      color="secondary"
      item-color="secondary"
      :rules="isRequired ? required : []"
      :multiple="multiple"
      :chips="chips"
      :solo="solo"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
      :single-line="singleLine"
      :outlined="outlined"
      :dense="dense"
      :hide-details="hideDetails"
  ></v-autocomplete>

</template>

<script>

import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'


import LocalityProvider from "../../providers/LocalityProvider"

export default {
  name: "LocalityCombobox",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {type: [String, Array]},
    multiple: {type: Boolean, default: false},
    chips: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
    isRequired: {type: Boolean, default: false},
    defaultFirst: {type: Boolean, default: false},
    itemValue: {type: String, default: 'id'},
    dense: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
    solo: {type: Boolean, default: false},
    singleLine: {type: Boolean, default: false},
    outlined: {type: Boolean, default: false},
    hideDetails: {type: Boolean, default: false},
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    item: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    },
    fetch() {
      this.loading = true
      LocalityProvider.fetchLocality().then(r => {
        this.items = r.data.fetchLocality

        if(this.defaultFirst && !this.item && this.items && this.items.length > 0){
          this.$emit('input', this.items[0].locality)
        }

      }).catch(err => console.error(err))
          .finally(() => this.loading = false)
    },


  }
}
</script>

<style scoped>

</style>
